import axios from 'axios';
export const portalRole = 'customer';
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || '/api',
  withCredentials: true,
  timeout: 60000,
  headers: { 'X-Portal-Role': portalRole, 'X-Portal-Request': '1' },
});
api.interceptors.response.use(response => response, error => {
  if (error.response?.data?.error?.message) error.message = error.response.data.error.message;
  return Promise.reject(error);
});
export default api;
